import React from 'react'
import { Tooltip } from '@mui/material'
import { StyledIconButton, StyledIcon } from '../styles'
import { useModal } from '@app/helpers'
import { faCalculator } from '@fortawesome/pro-solid-svg-icons/faCalculator'
import { CalculatorDraggableModal } from '../../CalculatorDraggableModal'
import { useSnapshot } from 'valtio'
import { CurrentUserAssessmentState, ScoringState } from '@app/storage'
import ToolsMenuItem from './ToolsMenuItem'
import { isCalculatorAvailable } from './isCalculatorAvailable'
import { useFeatureFlag } from '@app/helpers/hooks'
import { FeatureFlagName } from '@app/services/featureFlags/types'

export type Props = {
  isReviewMode: boolean
  isMobile?: boolean
}

const Calculator: React.FC<Props> = ({ isReviewMode, isMobile = false }) => {
  const { open, onOpen, onClose } = useModal(false)
  const { program, courseCategory } = useSnapshot(CurrentUserAssessmentState)
  const { isPreviewMode } = useSnapshot(ScoringState)
  const isRolloutEnabled = useFeatureFlag(FeatureFlagName.student_experience_calculator)

  if (!isCalculatorAvailable({ program, courseCategory, isReviewMode, isPreviewMode, isRolloutEnabled })) {
    return null
  }

  return (
    <>
      {isMobile ? (
        <ToolsMenuItem
          icon={faCalculator}
          label='Calculator'
          checked={open}
          onChange={open ? onClose : onOpen}
        />
      ) : (
        <Tooltip title='Calculator'>
          <StyledIconButton
            aria-label='Calculator'
            aria-pressed={open}
            onClick={open ? onClose : onOpen}
            className={open ? 'active' : ''}
          >
            <StyledIcon icon={faCalculator} />
          </StyledIconButton>
        </Tooltip>
      )}

      <CalculatorDraggableModal open={open} onClose={onClose} />
    </>
  )
}

export default Calculator
